import React from 'react';
import {
  canEditSection,
  useSidebarSectionsContext,
  useUpdateSidebarSection,
} from './SidebarSectionsProvider';
import useAppSelector from '../app/redux/useAppSelector';
import { MenuItem } from '../components/Menu';
import { UserType } from '../graphql/generated/graphql';
import clearIcon from '../icons/non-prefilled/16x16/clear.svg';

interface RemoveFromSectionMenuItemProps {
  sectionId: string;
  itemId: string;
}
const RemoveFromSectionMenuItem = ({
  sectionId,
  itemId,
}: RemoveFromSectionMenuItemProps) => {
  const { allSections } = useSidebarSectionsContext();
  const [updateSidebarSection] = useUpdateSidebarSection();
  const section = allSections.find(({ id }) => id === sectionId);
  const isAdmin = useAppSelector(
    (state) => state.session.user.type === UserType.Admin,
  );

  if (
    !section ||
    !canEditSection(sectionId, {
      isTeamSection: section.isTeamSection,
      isAdminUser: isAdmin,
    })
  ) {
    return null;
  }

  return (
    <MenuItem
      icon={clearIcon}
      onClick={() =>
        updateSidebarSection({
          variables: {
            id: section.id,
            itemIds: section.items
              .filter(({ id }) => id !== itemId)
              .map(({ id }) => id),
          },
        })
      }
    >
      Remove from section
    </MenuItem>
  );
};

export default RemoveFromSectionMenuItem;
